import React, { useContext, useState } from "react"

type SetHeaderHidden = (hidden: boolean) => void

const HeaderHiddenContext = React.createContext<boolean | undefined>(undefined)
const SetHeaderHiddenContext = React.createContext<SetHeaderHidden | undefined>(undefined)

export const HeaderVisibilityProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [headerHidden, setHeaderHidden] = useState(false)

  return (
    <SetHeaderHiddenContext.Provider value={setHeaderHidden}>
      <HeaderHiddenContext.Provider value={headerHidden}>{children}</HeaderHiddenContext.Provider>
    </SetHeaderHiddenContext.Provider>
  )
}

export const useHeaderHidden = (): boolean => {
  const value = useContext(HeaderHiddenContext)
  if (value === undefined) throw new Error("useHeaderHidden must be used within a HeaderVisibilityProvider")
  return value
}

export const useSetHeaderHidden = (): SetHeaderHidden => {
  const setter = useContext(SetHeaderHiddenContext)
  if (!setter) throw new Error("useSetHeaderHidden must be used within a HeaderVisibilityProvider")
  return setter
}
